import { Turbo } from '@hotwired/turbo-rails'

// Custom Turbo Stream action to reload frames
// Triggers the frame's native reload() method to refetch content from its src
Turbo.StreamActions.reload = function () {
  const frames = document.querySelectorAll(`turbo-frame#${this.target}`)

  frames.forEach((frame) => {
    if (frame.src) {
      frame.reload()
    } else if (frame.dataset.src) {
      frame.src = frame.dataset.src
    }
  })
}
